/**
 * Header account dropdown. Extends the theme's DetailsDisclosure
 * (details-disclosure.js — must load first) for hover open/close.
 * The <details> deliberately has NO href attribute, so the inherited
 * onClick (which listens on the whole <details>) no-ops and panel links
 * navigate normally. Pointer clicks on the summary go to /account;
 * keyboard activation toggles the panel so it stays reachable without
 * a mouse. wonderly-account-links.js ignores the summary (it only
 * matches <a> elements) — the /account links inside the panel carry
 * data-wonderly-account-link so its Klaviyo #k-hub protection covers
 * them instead.
 */
if (!customElements.get('wonderly-account-menu')) {
  customElements.define(
    'wonderly-account-menu',
    class WonderlyAccountMenu extends customElements.get('details-disclosure') {
      constructor() {
        super();
        this.summary = this.mainDetailsToggle.querySelector('summary');
        this.headerWrapper = document.querySelector('.header-wrapper');
        this.summary.addEventListener('click', this.onSummaryClick.bind(this));
        this.addEventListener('keyup', this.onKeyUp.bind(this));
        // Sticky-header protocol (see StickyHeader in sections/header.liquid):
        // while the panel is open the header must not hide/transform on scroll,
        // or the open panel detaches from it. HeaderMenu does this for nav
        // menus via onToggle; the native toggle event also clears the flag on
        // close, which HeaderMenu's open-only path misses.
        this.mainDetailsToggle.addEventListener('toggle', this.onNativeToggle.bind(this));
      }

      onNativeToggle() {
        if (!this.headerWrapper) return;
        this.headerWrapper.preventHide = this.mainDetailsToggle.open;
      }

      onSummaryClick(event) {
        // Keyboard "clicks" report detail 0 — let the native toggle run.
        if (event.detail === 0) return;
        event.preventDefault();
        window.location.assign(this.summary.dataset.accountUrl || '/account');
      }

      onKeyUp(event) {
        if (event.code !== 'Escape' || !this.mainDetailsToggle.hasAttribute('open')) return;
        this.close();
        this.summary.focus();
      }
    }
  );
}
